/** `[lng, lat]`. */
export type Punto = [number, number];

/**
 * Coordenadas que no son una ubicación sino el **valor por defecto de un
 * selector de mapa**: al crear una entidad sin mover el marcador, mapa-ubicar
 * (y sus parientes) guardan el centro de Buenos Aires. Esas entidades no
 * tienen ubicación real aunque el campo esté lleno: dibujarlas las amontonaba
 * en el Obelisco. Mismo criterio que FARO (compartido/luminarias/ubicacion.ts).
 */
export const UBICACIONES_POR_DEFECTO: readonly Punto[] = [
  [-58.381592, -34.603722], // mapa-ubicar
  [-58.3816, -34.6037], // mapa-ubicacion, mapa-unico-punto, autocomplete-direccion
  [-58.443832, -34.587386], // mapa-facil y el relleno de los layers del mapa
];

function esUbicacionPorDefecto([lng, lat]: Punto): boolean {
  return UBICACIONES_POR_DEFECTO.some(
    ([x, y]) => Math.abs(lng - x) < 1e-6 && Math.abs(lat - y) < 1e-6,
  );
}

/**
 * Un punto GeoJSON que se puede dibujar, o `null`: sin coordenadas, `[0, 0]`
 * o el valor por defecto de un selector.
 */
export function puntoValido(
  punto: { coordinates?: unknown } | null | undefined,
): Punto | null {
  const coords = punto?.coordinates;
  if (!Array.isArray(coords) || coords.length < 2) return null;
  const lng = Number(coords[0]);
  const lat = Number(coords[1]);
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null;
  if (lng === 0 && lat === 0) return null;
  if (esUbicacionPorDefecto([lng, lat])) return null;
  return [lng, lat];
}
